module.exports = require("@material-ui/icons/Wifi");